import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatLegacyRippleModule as MatRippleModule } from '@angular/material/legacy-core';
import { MatIconModule } from '@angular/material/icon';
import { FuseNavigationComponent } from './navigation.component';
import { FuseNavVerticalItemComponent } from './vertical/item/item.component';
import { FuseNavVerticalCollapsableComponent } from './vertical/collapsable/collapsable.component';
import { FuseNavVerticalGroupComponent } from './vertical/group/group.component';
import { FuseNavHorizontalItemComponent } from './horizontal/item/item.component';
import { FuseNavHorizontalCollapsableComponent } from './horizontal/collapsable/collapsable.component';
import { FuseNavVerticalTextComponent } from '@fuse/components/navigation/vertical/text/text.component';
import { TranslationModule } from '@core/translation/translation.module';

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        MatIconModule,
        MatRippleModule,
        TranslationModule
    ],
    exports     : [
        FuseNavigationComponent
    ],
    declarations: [
        FuseNavigationComponent,
        FuseNavVerticalGroupComponent,
        FuseNavVerticalItemComponent,
        FuseNavVerticalCollapsableComponent,
        FuseNavVerticalTextComponent,
        FuseNavHorizontalItemComponent,
        FuseNavHorizontalCollapsableComponent,
    ]
})
export class FuseNavigationModule
{
}
